import { CommercialTypes } from '../../../../../../../types/api/endpoints/commercial/commercial.types';
import { FormItem } from '../../../../../../commons/Form/Form.types';
import { SelectOption } from '../../../../../../commons/Select/Select.types';
import { DashboardCommerciauxFormSchema } from './DashboardCommerciauxUpdateForm.types';

export const updateCommercialStepData: FormItem<DashboardCommerciauxFormSchema>[][] = [
  [
    {
      name: 'firstName',
      placeholder: 'Votre prénom...',
      label: 'Prénom',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'lastName',
      placeholder: 'Votre nom...',
      label: 'Nom',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'type',
      placeholder: 'Choisissez un type...',
      label: 'Type de commercial',
      type: 'select',
      required: true,
      options: Object.values(CommercialTypes).map(option => ({
        label: option,
        value: option
      } as SelectOption)),
      // @ts-ignore
      defaultValue: {
        label: CommercialTypes.Employee,
        value: CommercialTypes.Employee
      } as SelectOption
    },
  ],
  [
    {
      name: 'phone',
      placeholder: 'Votre numéro de téléphone...',
      label: 'Téléphone',
      type: 'tel',
      required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'siret',
      placeholder: 'Votre Numéro SIRET...',
      label: 'Siret',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'tva',
      placeholder: 'Votre Numéro TVA...',
      label: 'N° TVA',
      type: 'text',
    },
  ],
  [
    {
      name: 'city',
      placeholder: 'Votre ville...',
      label: 'Ville',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'department',
      placeholder: 'Votre département...',
      label: 'Département',
      type: 'text',
      required: true,
    },
    {
      name: 'region',
      placeholder: 'Votre région...',
      label: 'Région',
      type: 'text',
      required: true,
    },
  ],
];
